if (!customElements.get('cart-terms')) {
  class CartTerms extends HTMLElement {
    constructor() {
      super();
      // One checkbox for the terms, a Ja / Nej radio pair for Dellevering — ticking any one passes.
      this.inputs = this.querySelectorAll('.js-cart-terms-checkbox');
      this.form = document.getElementById(this.inputs[0].getAttribute('form'));
      this.submitHandler = this.handleSubmit.bind(this);
      this.form.addEventListener('submit', this.submitHandler);
    }

    disconnectedCallback() {
      this.form.removeEventListener('submit', this.submitHandler);
    }

    /**
     * Handles cart form submit
     * @param {object} evt - Event object.
     */
    handleSubmit(evt) {
      // Another required box on the same form (terms / Dellevering) already blocked this submit
      // and showed its alert, so one checkout attempt gives one alert, not one per unticked box.
      if (evt.defaultPrevented) return;

      if (!Array.from(this.inputs).some((input) => input.checked)) {
        evt.preventDefault();
        alert(this.dataset.confirmation || theme.strings.cartTermsConfirmation); // eslint-disable-line
      }
    }
  }
  customElements.define('cart-terms', CartTerms);
}
